module.exports = __webpack_public_path__ + "img/CLINIQUE.9a9a4c53.png";